export default __webpack_public_path__ + "static/anna-d9f27206b24d863e633268367203b225.png";